const AUTH = 'AUTH'

let initialState = {

}

let headerReduser = (state = initialState, action) => {
  let newState = {...state};
  switch (action.type) {
    
  }
    return newState;
}


export default headerReduser;
